import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const LikeComentCounterSlice = createSlice({
  name: "counterComent",
  initialState: {
    counter: 0,
  },
  reducers: {
    increment: (state) => {
      state.counter += 1;
    },
    decrement: (state) => {
      state.counter -= 1;
    },
    valueInitial: (state, action) => {
      state.counter = action.payload;
    },
  },
});

// Экшены
export const { increment, decrement, valueInitial } =
  LikeComentCounterSlice.actions;

export default LikeComentCounterSlice.reducer;

// import { createSlice } from "@reduxjs/toolkit";

// // Начальное состояние
// const initialState = {
//   value: 0,
// };

// // Создаём слайс
// export const counterSlice = createSlice({
//   name: "counter", // Имя слайса — будет частью глобального состояния
//   initialState,
//   reducers: {
//     increment: (state) => {
//       state.value += 1;
//     },
//     decrement: (state) => {
//       state.value -= 1;
//     },
//     // Дополнительно: увеличиваем на заданную сумму
//     incrementByAmount: (state, action) => {
//       state.value += action.payload;
//     },
//   },
// });

// // Экспортируем создателями экшенов (для использования в компонентах)
// export const { increment, decrement, incrementByAmount } = counterSlice.actions;

// // Экспортируем редьюсер по умолчанию (его нужно подключить к хранилищу)
// export default counterSlice.reducer;

// // Опционально: селектор для удобного извлечения значения в компоненты
// export const selectCount = (state) => state.counter.value;
